(() => {
  const galleries = new WeakSet();
  const depths = new WeakSet();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const animate = (element, frames, options) => {
    if (preference.matches || typeof element.animate !== 'function') return;
    const animation = element.animate(frames, options);
    animations.add(animation);
    animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
  };
  preference.addEventListener?.('change', () => {if(preference.matches) {animations.forEach(animation => animation.cancel());animations.clear();}});
  function initializeGallery(gallery) {
    if (galleries.has(gallery)) return;
    galleries.add(gallery);
    const cards = [...gallery.querySelectorAll('[data-mbm-result]')];
    const filters = [...gallery.querySelectorAll('[data-mbm-filter]')];
    const dialog = gallery.querySelector('dialog');
    let active = 0;
    let opener;
    const visible = () => cards.filter(card => !card.hidden);
    function display(card) {
      active = cards.indexOf(card);
      const source = card.querySelector('img');
      const image = dialog.querySelector('[data-mbm-dialog-image]');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      dialog.querySelector('[data-mbm-dialog-title]').textContent = card.querySelector('h3').textContent;
      dialog.querySelector('[data-mbm-dialog-caption]').textContent = card.querySelector('figcaption p').textContent;
      const single = visible().length < 2;
      dialog.querySelector('[data-mbm-dialog-prev]').disabled = single;
      dialog.querySelector('[data-mbm-dialog-next]').disabled = single;
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else { dialog.removeAttribute('open'); restore(); }
    }
    function restore() { document.body.classList.remove('mbm-result-open'); opener?.focus(); }
    filters.forEach(button => button.addEventListener('click', () => {
      filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
      const group = button.dataset.mbmFilter;
      cards.forEach(card => {
        card.hidden = group !== 'all' && card.dataset.mbmGroup !== group;
        if (!card.hidden) animate(card, [{opacity:.4,translate:'0 12px'},{opacity:1,translate:'0 0'}],{duration:380,easing:'ease-out'});
      });
      gallery.querySelector('[data-mbm-gallery-status]').textContent = 'מוצגות ' + visible().length + ' דוגמאות';
    }));
    cards.forEach(card => card.querySelector('[data-mbm-open]').addEventListener('click', event => {
      opener = event.currentTarget;
      display(card);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.body.classList.add('mbm-result-open');
      dialog.querySelector('[data-mbm-dialog-close]').focus();
      animate(dialog,[{opacity:.4,translate:'0 12px'},{opacity:1,translate:'0 0'}],{duration:260,easing:'ease-out'});
    }));
    dialog.querySelector('[data-mbm-dialog-close]').addEventListener('click', close);
    dialog.addEventListener('close', restore);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    function next(direction) {
      const list = visible();
      const index = list.indexOf(cards[active]);
      display(list[(index + direction + list.length) % list.length]);
    }
    dialog.querySelector('[data-mbm-dialog-prev]').addEventListener('click', () => next(-1));
    dialog.querySelector('[data-mbm-dialog-next]').addEventListener('click', () => next(1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') {event.preventDefault();next(1);}
      if (event.key === 'ArrowRight') {event.preventDefault();next(-1);}
      if (event.key === 'Escape' && typeof dialog.close !== 'function') {event.preventDefault();close();}
      if (event.key === 'Tab' && typeof dialog.showModal !== 'function') {
        const focusable = [...dialog.querySelectorAll('button')].filter(button => !button.disabled);
        if (event.shiftKey && document.activeElement === focusable[0]) {event.preventDefault();focusable.at(-1).focus();}
        else if (!event.shiftKey && document.activeElement === focusable.at(-1)) {event.preventDefault();focusable[0].focus();}
      }
    });
    // Removing the section in the theme editor must release the page scroll lock.
    document.addEventListener('shopify:section:unload', event => {if(event.target.contains(gallery) && dialog.open) close();});
  }
  function initializeDepth(hero) {
    if (depths.has(hero)) return;
    depths.add(hero);
    const cards = [...hero.querySelectorAll('[data-mbm-depth-card]')];
    const reset = () => cards.forEach(card => {card.style.removeProperty('--mbm-depth-x');card.style.removeProperty('--mbm-depth-y');});
    hero.addEventListener('pointermove', event => {
      if (preference.matches || event.pointerType !== 'mouse') return;
      const rect = hero.getBoundingClientRect();
      const x = Math.max(-1,Math.min(1,(event.clientX - rect.left) / rect.width * 2 - 1));
      const y = Math.max(-1,Math.min(1,(event.clientY - rect.top) / rect.height * 2 - 1));
      cards.forEach((card,index) => {const depth=index===0?4:7;card.style.setProperty('--mbm-depth-x',(x*depth).toFixed(2)+'px');card.style.setProperty('--mbm-depth-y',(y*depth).toFixed(2)+'px');});
    });
    hero.addEventListener('pointerleave', reset);
    preference.addEventListener?.('change',reset);
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-mbm-gallery]').forEach(initializeGallery);
    scope.querySelectorAll('[data-mbm-depth]').forEach(initializeDepth);
  }
  initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
